import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
  Container,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import lorem from "../../utilities/loremIpsum";
import { SplashContext } from "../layout/layout";

const TermsPage = () => {
  const splashScreen = useContext(SplashContext);
  useEffect(() => {
    splashScreen();
    // eslint-disable-next-line
  }, []);
  return (
    <Container maxWidth="lg">
      <Stack
        spacing={1}
        sx={{ pt: 3, alignItems: "center", minHeight: "90vh" }}
      >
        <Typography variant="h5" color={"black"}>
          Terms and conditions
        </Typography>
      </Stack>
    </Container>
  );
};

const TermsDialog = ({ open, setOpen, onAccept }) => {
  const handleClose = () => {
    setOpen(false);
  };
  const [terms /*setTerms */] = useState(
    lorem.generateSentences(10).split(". ")
  );
  return (
    <Dialog open={open} onClose={() => handleClose()} maxWidth="sm" fullWidth>
      <DialogTitle>Terms and conditions</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <List sx={{ height: "60vh", overflowY: "auto" }}>
            {terms.map((term, index) => (
              <ListItem key={"term" + index}>
                <ListItemText>
                  {index + 1}.&emsp;{term}
                </ListItemText>
              </ListItem>
            ))}
          </List>
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              sx={{ width: "fit-content" }}
              onClick={() => {
                onAccept();
                handleClose();
              }}
            >
              Accept
            </Button>
            <Button
              variant="outlined"
              sx={{ width: "fit-content" }}
              onClick={() => {
                handleClose();
              }}
            >
              Decline
            </Button>
          </Stack>
        </Stack>
        {/* <Divider/>
                <DialogContentText>Sign in</DialogContentText> */}
      </DialogContent>
    </Dialog>
  );
};
export default TermsPage;
export { TermsDialog };
